import { render, staticRenderFns } from "./CgmCoreParamTable.vue?vue&type=template&id=76174ae5&scoped=true"
import script from "./CgmCoreParamTable.vue?vue&type=script&lang=js"
export * from "./CgmCoreParamTable.vue?vue&type=script&lang=js"
import style0 from "./CgmCoreParamTable.vue?vue&type=style&index=0&id=76174ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76174ae5",
  null
  
)

export default component.exports